export const environment = {
  production: true,
  apiUrl: 'https://api.test.guidl.tours',
};
